import { render, staticRenderFns } from "./DynamiCall.vue?vue&type=template&id=6a79c5a2&scoped=true"
import script from "./DynamiCall.vue?vue&type=script&lang=js"
export * from "./DynamiCall.vue?vue&type=script&lang=js"
import style0 from "./DynamiCall.vue?vue&type=style&index=0&id=6a79c5a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a79c5a2",
  null
  
)

export default component.exports